module.exports = __webpack_public_path__ + "img/7.b18d398d.png";